export const TEMPLATE_PARAM_CATALOG = [
    // ── Fees & commercial values ──────────────────────────────────────────────────────────────────
    { key: 'insuranceCap', group: 'FEES', label: 'Insurance cap', unit: 'JOD', default: 100, min: 0, max: 100_000 },
    { key: 'insuranceRate', group: 'FEES', label: 'Insurance rate', unit: 'fraction', default: 0.005, min: 0, max: 0.5 },
    { key: 'registrationFee', group: 'FEES', label: 'Registration fee', unit: 'JOD', default: 50, min: 0, max: 100_000 },
    { key: 'generalFee', group: 'FEES', label: 'General fees', unit: 'JOD', default: 100, min: 0, max: 100_000 },
    {
        key: 'registrationThresholdDays',
        group: 'FEES',
        label: 'Registration threshold',
        unit: 'days',
        default: 40,
        min: 0,
        max: 365,
        integer: true,
    },
    { key: 'ownershipTransferRate', group: 'FEES', label: 'Ownership-transfer rate', unit: 'fraction', default: 0.006, min: 0, max: 0.5 },
    { key: 'licensingRate', group: 'FEES', label: 'Licensing rate', unit: 'fraction', default: 0.03, min: 0, max: 0.5 },
    { key: 'commissionFee', group: 'FEES', label: 'Sales commission', unit: 'JOD', default: 300, min: 0, max: 100_000 },
    {
        key: 'overheadRate',
        group: 'FEES',
        label: 'Overhead rate',
        unit: 'fraction',
        default: 0.01,
        min: 0,
        max: 0.5,
        provisional: true,
        description: 'On the source-compatible base. The base itself awaits Finance approval (PP §11).',
    },
    {
        key: 'dailyHoldingRate',
        group: 'FEES',
        label: 'Daily holding rate',
        unit: 'JOD/day',
        default: 0,
        min: 0,
        max: 1_000,
        provisional: true,
        description: 'Seeded at zero: a daily holding cost is unapproved and must not be silently invented (PP §7.3).',
    },
    { key: 'roundingIncrement', group: 'FEES', label: 'Commercial rounding increment', unit: 'JOD', default: 100, min: 0.001, max: 10_000 },
    { key: 'targetProfit', group: 'FEES', label: 'Target profit', unit: 'JOD', default: 800, min: 0, max: 1_000_000, provisional: true },
    { key: 'targetMargin', group: 'FEES', label: 'Target gross margin', unit: 'fraction', default: 0.08, min: 0, max: 0.9, provisional: true },
    { key: 'riskBuffer', group: 'FEES', label: 'Risk buffer', unit: 'JOD', default: 300, min: 0, max: 1_000_000, provisional: true },
    { key: 'expectedHoldingDays', group: 'FEES', label: 'Expected holding days', unit: 'days', default: 30, min: 0, max: 3_650, integer: true },
    { key: 'fuelLiters', group: 'FEES', label: 'Fuel litres', unit: 'L', default: 20, min: 0, max: 1_000 },
    { key: 'fuelPricePerLiter', group: 'FEES', label: 'Fuel price per litre', unit: 'JOD/L', default: 1, min: 0, max: 100 },
    // ── Depreciation, mileage & owners ────────────────────────────────────────────────────────────
    { key: 'depYear1', group: 'DEPRECIATION', label: 'Year 1 depreciation', unit: 'fraction', default: 0.15, min: 0, max: 0.9 },
    { key: 'depYear2', group: 'DEPRECIATION', label: 'Year 2 depreciation', unit: 'fraction', default: 0.1, min: 0, max: 0.9 },
    { key: 'depYear3', group: 'DEPRECIATION', label: 'Year 3 depreciation', unit: 'fraction', default: 0.07, min: 0, max: 0.9 },
    { key: 'depYear4', group: 'DEPRECIATION', label: 'Year 4 increment', unit: 'fraction', default: 0.05, min: 0, max: 0.9 },
    {
        key: 'annualMileageAllowance',
        group: 'DEPRECIATION',
        label: 'Annual mileage allowance',
        unit: 'km/year',
        default: 20_000,
        min: 1,
        max: 200_000,
    },
    { key: 'mileageStepKm', group: 'DEPRECIATION', label: 'Excess mileage step', unit: 'km', default: 20_000, min: 1, max: 200_000 },
    { key: 'mileageStepRate', group: 'DEPRECIATION', label: 'Penalty per mileage step', unit: 'fraction', default: 0.005, min: 0, max: 0.5 },
    { key: 'ownerAllowance', group: 'DEPRECIATION', label: 'Owner allowance', unit: 'count', default: 5, min: 0, max: 50, integer: true },
    { key: 'ownerStepRate', group: 'DEPRECIATION', label: 'Penalty per additional owner', unit: 'fraction', default: 0.01, min: 0, max: 0.5 },
    {
        key: 'faceliftRate',
        group: 'DEPRECIATION',
        label: 'Facelift deduction',
        unit: 'fraction',
        default: 0.11,
        min: 0,
        max: 0.9,
        provisional: true,
        description: 'Applies only when the vehicle is marked as superseded by a facelift. Unknown is not No.',
    },
    {
        key: 'customsImpactRate',
        group: 'DEPRECIATION',
        label: 'Customs market impact',
        unit: 'fraction',
        default: 0.16,
        min: 0,
        max: 0.9,
        provisional: true,
        description: 'A market-value adjustment, not a tax charge. Unapproved (PP §7.3).',
    },
    // ── Inspection & inclusions ───────────────────────────────────────────────────────────────────
    { key: 'severityExcellent', group: 'INSPECTION', label: 'Excellent', unit: 'fraction', default: 0, min: 0, max: 0.5 },
    { key: 'severityMinor', group: 'INSPECTION', label: 'Minor', unit: 'fraction', default: 0.005, min: 0, max: 0.5 },
    { key: 'severityModerate', group: 'INSPECTION', label: 'Moderate', unit: 'fraction', default: 0.01, min: 0, max: 0.5 },
    {
        key: 'severityMajor',
        group: 'INSPECTION',
        label: 'Major',
        unit: 'fraction',
        default: 0.015,
        min: 0,
        max: 0.5,
        provisional: true,
        description: 'Awaiting business calibration, especially for engine and hybrid faults (PP §7.3).',
    },
    { key: 'severitySevere', group: 'INSPECTION', label: 'Severe', unit: 'fraction', default: 0.02, min: 0, max: 0.5, provisional: true },
    { key: 'gradeG7', group: 'INSPECTION', label: '7 جيد', unit: 'fraction', default: 0, min: 0, max: 0.9 },
    { key: 'gradeG4', group: 'INSPECTION', label: '4 جيد', unit: 'fraction', default: 0, min: 0, max: 0.9 },
    { key: 'gradeG3', group: 'INSPECTION', label: '3 جيد', unit: 'fraction', default: 0.05, min: 0, max: 0.9 },
    { key: 'gradeG2', group: 'INSPECTION', label: '2 جيد', unit: 'fraction', default: 0.1, min: 0, max: 0.9 },
    { key: 'gradeG1', group: 'INSPECTION', label: '1 جيد', unit: 'fraction', default: 0.15, min: 0, max: 0.9 },
    { key: 'gradeG0', group: 'INSPECTION', label: '0 جيد', unit: 'fraction', default: 0.2, min: 0, max: 0.9 },
    { key: 'spareKeyValue', group: 'INSPECTION', label: 'Spare key value', unit: 'JOD', default: 50, min: 0, max: 10_000 },
    { key: 'ownersManualValue', group: 'INSPECTION', label: 'Owner’s manual value', unit: 'JOD', default: 50, min: 0, max: 10_000 },
    { key: 'toolKitValue', group: 'INSPECTION', label: 'Tool kit value', unit: 'JOD', default: 50, min: 0, max: 10_000 },
    { key: 'spareTireValue', group: 'INSPECTION', label: 'Spare tyre value', unit: 'JOD', default: 100, min: 0, max: 10_000 },
    // ── Current-work estimate values ──────────────────────────────────────────────────────────────
    { key: 'minorBodyRate', group: 'WORK', label: 'Minor body work', unit: 'fraction', default: 0.003, min: 0, max: 0.5 },
    { key: 'mediumBodyRate', group: 'WORK', label: 'Medium body work', unit: 'fraction', default: 0.01, min: 0, max: 0.5 },
    { key: 'majorBodyRate', group: 'WORK', label: 'Major body work', unit: 'fraction', default: 0.04, min: 0, max: 0.5 },
    { key: 'batteryRate', group: 'WORK', label: 'Battery replacement', unit: 'fraction', default: 0.0025, min: 0, max: 0.5 },
    { key: 'oilServiceFee', group: 'WORK', label: 'Oil service', unit: 'JOD', default: 25, min: 0, max: 10_000 },
    // ── Trade-in shared values ────────────────────────────────────────────────────────────────────
    { key: 'demandHigh', group: 'TRADE_IN', label: 'High demand factor', unit: 'fraction', default: 0.02, min: 0, max: 0.5 },
    { key: 'demandMedium', group: 'TRADE_IN', label: 'Medium demand factor', unit: 'fraction', default: 0.01, min: 0, max: 0.5 },
    { key: 'demandLow', group: 'TRADE_IN', label: 'Low demand factor', unit: 'fraction', default: 0, min: 0, max: 0.5 },
    { key: 'stockLow', group: 'TRADE_IN', label: 'Low stock factor', unit: 'fraction', default: 0.02, min: 0, max: 0.5 },
    { key: 'stockMedium', group: 'TRADE_IN', label: 'Medium stock factor', unit: 'fraction', default: 0.01, min: 0, max: 0.5 },
    { key: 'stockHigh', group: 'TRADE_IN', label: 'High stock factor', unit: 'fraction', default: 0, min: 0, max: 0.5 },
    {
        key: 'supportCap',
        group: 'TRADE_IN',
        label: 'Support cap',
        unit: 'JOD',
        default: 500,
        min: 0,
        max: 100_000,
        provisional: true,
        description: 'Finance-approved cap on calculated trade-in support (PP §7.4).',
    },
];
const PARAMS_BY_KEY = new Map(TEMPLATE_PARAM_CATALOG.map((entry) => [entry.key, entry]));
export const findParam = (key) => PARAMS_BY_KEY.get(key);
export const PARAM_KEYS = TEMPLATE_PARAM_CATALOG.map((entry) => entry.key);
export const paramsByGroup = (group) => TEMPLATE_PARAM_CATALOG.filter((entry) => entry.group === group);
/**
 * The values an individual estimate or vehicle may override (plan §3.3, §5.2). Everything else is the
 * template's alone, so that "two templates, same formula, different caps" stays true (PP AC20).
 */
export const DEFAULT_OVERRIDABLE_KEYS = [
    'commissionFee',
    'generalFee',
    'registrationFee',
    'fuelLiters',
    'expectedHoldingDays',
    'targetProfit',
    'targetMargin',
    'riskBuffer',
];
/** The first damage group's fixed JOD effects, index 0 = "none" (PP §7.3). */
const DAMAGE_GROUP_1_STANDARD = [0, 200, 0, 500, 200, 1500, 1000];
const DAMAGE_GROUP_1_LUXURY = [0, 500, 0, 1500, 500, 2500, 2000];
const DAMAGE_GROUP_2_STANDARD = [0, 0, 200, 100, 0, 0, 1000];
const DAMAGE_GROUP_2_LUXURY = [0, 0, 500, 500, 250, 0, 3000];
/**
 * The Arabic damage notes, stored as an index plus the canonical Arabic label with an English gloss
 * (plan §2.7). The wording is the source inventory's and is not translated away.
 */
export const DAMAGE_GROUP_1_OPTIONS = [
    { index: 0, arabic: 'لا يوجد', english: 'None' },
    { index: 1, arabic: 'جيد / قصعات راسية', english: 'Good / vertical dents' },
    { index: 2, arabic: 'غيار جناح امامي تبديل ابواب', english: 'Front wing replaced, doors changed' },
    { index: 3, arabic: 'مضروب / قصعات راسية / غيار جناح خلفي / عين الضوء', english: 'Hit / vertical dents / rear wing replaced / lamp housing' },
    {
        index: 4,
        arabic: 'قصعات بالتندة / ضربات بودي مشغولة / ضربة امامية / ضربة خلفية',
        english: 'Bonnet dents / worked body impacts / front impact / rear impact',
    },
    { index: 5, arabic: 'قص جناح / قص مرش', english: 'Cut wing / cut sill' },
    { index: 6, arabic: 'قصعات تندة اثر برد', english: 'Bonnet dents from hail' },
];
export const DAMAGE_GROUP_2_OPTIONS = [
    { index: 0, arabic: 'لا يوجد', english: 'None' },
    { index: 1, arabic: 'جيد', english: 'Good' },
    { index: 2, arabic: 'قصعات بالتندة / شمعة امامية / شمعة خلفية', english: 'Bonnet dents / front lamp / rear lamp' },
    { index: 3, arabic: 'غيار عين ضوء', english: 'Lamp housing replaced' },
    { index: 4, arabic: 'ضربات بودي ومشغولة', english: 'Body impacts, worked' },
    { index: 5, arabic: 'ضربات بودي / كحتات / نقرات ( بحاجة دهان )', english: 'Body impacts / scuffs / chips (needs paint)' },
    { index: 6, arabic: 'قص / لحام شاصي', english: 'Chassis cut or welded' },
];
/**
 * Starter presets **only pre-fill rates** (plan §3.2): picking one copies numbers into the draft, and
 * the template version then owns them. Note that generic "Luxury" is not treated like "Markazia-Luxury"
 * in the grade table — the product plan is explicit that the luxury treatment is not extended silently.
 */
export const DEPRECIATION_PRESETS = [
    {
        key: 'MARKAZIA_NORMAL',
        label: 'Markazia Normal',
        rates: [0.15, 0.1, 0.07, 0.05],
        damageGroup1: DAMAGE_GROUP_1_STANDARD,
        damageGroup2: DAMAGE_GROUP_2_STANDARD,
    },
    {
        key: 'MARKAZIA_LUXURY',
        label: 'Markazia-Luxury',
        rates: [0.2, 0.15, 0.1, 0.05],
        gradeRates: { G7: 0, G4: 0, G3: 0.2, G2: 0.3, G1: 0.4, G0: 0.6 },
        damageGroup1: DAMAGE_GROUP_1_LUXURY,
        damageGroup2: DAMAGE_GROUP_2_LUXURY,
    },
    {
        key: 'NORMAL',
        label: 'Normal',
        rates: [0.2, 0.15, 0.1, 0.05],
        damageGroup1: DAMAGE_GROUP_1_STANDARD,
        damageGroup2: DAMAGE_GROUP_2_STANDARD,
    },
    {
        key: 'LUXURY',
        label: 'Luxury',
        rates: [0.25, 0.2, 0.1, 0.05],
        damageGroup1: DAMAGE_GROUP_1_STANDARD,
        damageGroup2: DAMAGE_GROUP_2_STANDARD,
    },
];
export const findPreset = (key) => DEPRECIATION_PRESETS.find((preset) => preset.key === key) ?? DEPRECIATION_PRESETS[0];
/** Every catalogue key at its workbook default. */
export const defaultParams = () => Object.fromEntries(TEMPLATE_PARAM_CATALOG.map((entry) => [entry.key, entry.default]));
/** The catalogue defaults with a starter preset's rates applied on top. */
export const paramsForPreset = (key) => {
    const preset = findPreset(key);
    const params = defaultParams();
    preset.rates.forEach((rate, index) => {
        params[`depYear${index + 1}`] = rate;
    });
    for (const [grade, rate] of Object.entries(preset.gradeRates ?? {})) {
        params[`grade${grade}`] = rate;
    }
    return params;
};
/** The severity table key an inspection selection reads. */
export const severityParamKey = (severity) => `severity${severity.charAt(0)}${severity.slice(1).toLowerCase()}`;
/** The grade table key a سبعة جيد selection reads. */
export const gradeParamKey = (grade) => `grade${grade}`;
/** Validation rules a template version must satisfy before it can be published (plan §5.10). */
export const validateParams = (params) => {
    const issues = [];
    for (const key of Object.keys(params)) {
        if (!PARAMS_BY_KEY.has(key)) {
            issues.push({ key, code: 'UNKNOWN_KEY', detail: `"${key}" is not a template value` });
        }
    }
    for (const definition of TEMPLATE_PARAM_CATALOG) {
        const value = params[definition.key];
        if (value === undefined || value === null) {
            issues.push({ key: definition.key, code: 'MISSING', detail: `${definition.label} is required` });
            continue;
        }
        if (typeof value !== 'number' || !Number.isFinite(value)) {
            issues.push({ key: definition.key, code: 'NOT_FINITE', detail: `${definition.label} must be a number` });
            continue;
        }
        if (value < definition.min || value > definition.max) {
            issues.push({
                key: definition.key,
                code: 'OUT_OF_RANGE',
                detail: `${definition.label} must be between ${definition.min} and ${definition.max}`,
            });
        }
        if (definition.integer && !Number.isInteger(value)) {
            issues.push({ key: definition.key, code: 'NOT_INTEGER', detail: `${definition.label} must be a whole number` });
        }
    }
    return issues;
};
//# sourceMappingURL=param-catalog.js.map